import { render, staticRenderFns } from "./RequesterReviewPostingLifecycle.vue?vue&type=template&id=c2d0c6aa"
import script from "./RequesterReviewPostingLifecycle.vue?vue&type=script&lang=js"
export * from "./RequesterReviewPostingLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports